import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

export interface NoteWithStatus {
  status: string;
  notes: string;
  startTime?: string;
  endTime?: string;
  employeeId?: string;
  customerId?: string;
  eventId?: string;
}

interface NotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  notesList: NoteWithStatus[];
}

export const NotesModal: React.FC<NotesModalProps> = ({
  isOpen,
  onClose,
  notesList,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delivery Notes</DialogTitle>
      <DialogContent dividers style={{ whiteSpace: "pre-wrap" }}>
        {notesList.length === 0 && <Typography>No notes available.</Typography>}
        {notesList.map((note, i) => (
          <div key={i} style={{ marginBottom: "1.5rem" }}>
            <Typography variant="subtitle2" style={{ fontWeight: "bold", marginBottom: 4 }}>
              Status: {note.status?.toUpperCase() || "N/A"}
            </Typography>
            {(note.startTime || note.endTime) && (
              <Typography variant="caption" color="textSecondary" style={{ marginBottom: "2.0rem" }}>
                {note.startTime && <div>Start: {note.startTime}</div>}
                {note.endTime && <div style={{ marginBottom: "1.0rem" }}>End: {note.endTime}</div>}
              </Typography>
            )}
            <Typography variant="body2" gutterBottom>
              <strong>Employee ID:</strong> {note.employeeId || "N/A"}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>Customer ID:</strong> {note.customerId || "N/A"}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>Event ID:</strong> {note.eventId || "N/A"}
            </Typography>
            <Typography component="pre" style={{ whiteSpace: "pre-wrap" }}>
              {note.notes || "No notes."}
            </Typography>
            {i !== notesList.length - 1 && <hr />}
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

